import {
  Box,
  FormProvider,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
} from "dash-ui";

import ArchiveUserModal from "./components/ArchiveUserModal/ArchiveUserModal";
import ApiCompaniesPageHeader from "./components/ApiCompaniesPageHeader/ApiCompaniesPageHeader";
import ApiCompaniesPageTable from "./components/ApiCompaniesPageTable/ApiCompaniesPageTable";
import SaveCompanyModal from "./components/SaveCompanyModal/SaveCompanyModal";
import DeleteCmsUserModal from "./components/DeleteCmsUserModal/DeleteCmsUserModal";
import { CreateUserFormFieldsList } from "../constants/constants";

const ApiCompaniesPage = () => (
  <PaginationProvider>
    <SortProvider>
      <SearchProvider>
        <ModalProvider>
          <FormProvider fieldsList={CreateUserFormFieldsList}>
            <Box w="100%">
              <ArchiveUserModal />
              <ApiCompaniesPageHeader />
              <ApiCompaniesPageTable />
              <SaveCompanyModal />
              <DeleteCmsUserModal />
            </Box>
          </FormProvider>
        </ModalProvider>
      </SearchProvider>
    </SortProvider>
  </PaginationProvider>
);

export default ApiCompaniesPage;
